import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '@app/core/app-config';
import { BehaviorSubject, map } from 'rxjs';
import { SentimentAnalysisService } from './sentiment-analysis/sentiment-analysis.service';
import { ThreadPayload } from './thread/thread.service';

export interface ThreadIssueAlert {
  uuid: string;
  title: string;
  severity: string | null;
  category: string | null;
  resolved_at: string | null;
  dismissed_at: string | null;
  created_at: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root',
})
export class ThreadSentimentLabelService {
  private threadUrl = `${config.API_URL}/threads/`;

  public label$ = new BehaviorSubject<string | null>(null);
  public labelUuid$ = new BehaviorSubject<string | null>(null);

  constructor(
    private sentimentAnalysisService: SentimentAnalysisService,
    private http: HttpClient
  ) {}

  setSentimentLabel(thread: ThreadPayload) {
    if (!this.sentimentAnalysisService.enabled$.value) return;

    this.getThreadSentiment(thread.uuid).subscribe((alert) => {
      if (alert && !alert.dismissed_at) {
        this.label$.next(alert.title);
        this.labelUuid$.next(alert.uuid);
        return;
      }

      this.label$.next(thread.label);
      this.labelUuid$.next(null);
    });
  }

  getThreadSentiment(threadUuid: string) {
    const url = `${this.threadUrl}${threadUuid}/active-issue-alert`;

    return this.http.get<{ data: ThreadIssueAlert }>(url).pipe(map((res) => res.data));
  }

  dismissCancelReviewRequest(threadUuid: string) {
    return this.http
      .post<{ data: ThreadPayload }>(`${this.threadUrl}${threadUuid}/cancel-review-request/dismiss`, {})
      .pipe(map((res) => res.data));
  }

  cancelReviewRequest(threadUuid: string) {
    return this.http
      .post<{ data: ThreadPayload }>(`${this.threadUrl}${threadUuid}/cancel-review-request/confirm`, {})
      .pipe(map((res) => res.data));
  }

  dismissThreadLabel(threadUuid: string) {
    return this.http.post<{ data: ThreadPayload }>(`${this.threadUrl}${threadUuid}/dismiss-issue-alerts`, {});
  }
}
